import { Link } from "react-router-dom";
import scholzLogo from "@/assets/scholz-logo.png";
export const Footer = () => {
  return <footer className="relative bg-primary/5 dark:bg-primary/10 py-8 sm:py-12 lg:py-20 overflow-hidden border-t border-primary/15">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-1/4 w-32 h-32 sm:w-64 sm:h-64 rounded-full blur-3xl bg-primary/8"></div>
        <div className="absolute bottom-10 right-1/3 w-24 h-24 sm:w-48 sm:h-48 rounded-full blur-2xl bg-primary/6"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12 mb-8 sm:mb-12">
            
            {/* Logo and Company Info - Spans full width on mobile */}
            <div className="sm:col-span-2 lg:col-span-1 space-y-3 sm:space-y-4">
              <Link to="/" className="inline-block">
                <img src={scholzLogo} alt="Scholz Interim" className="h-7 sm:h-8 opacity-90 hover:opacity-100 transition-opacity" />
              </Link>
              <p className="text-xs sm:text-sm text-foreground/80 leading-relaxed max-w-md">
                25 Jahre Erfahrung in der Interim Management Beratung. 
                Diskrete, professionelle Lösungen für Unternehmen und Führungskräfte.
              </p>
            </div>
            
            {/* Services */}
            <div className="space-y-3 sm:space-y-4">
              <h4 className="font-medium text-sm sm:text-base text-foreground">Services</h4>
              <nav className="space-y-1.5 sm:space-y-2">
                <Link to="/unternehmen" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Für Unternehmen
                </Link>
                <Link to="/bewerbende" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Für Bewerbende
                </Link>
                <Link to="/verpachtung" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Verpachtung
                </Link>
                <a href="/#expertise" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Expertise
                </a>
              </nav>
            </div>
            
            {/* Company */}
            <div className="space-y-3 sm:space-y-4">
              <h4 className="font-medium text-sm sm:text-base text-foreground">Unternehmen</h4>
              <nav className="space-y-1.5 sm:space-y-2">
                <a href="/#about" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Über uns
                </a>
                
                <a href="/#contact" className="block text-xs sm:text-sm text-foreground/70 hover:text-foreground transition-smooth">
                  Kontakt
                </a>
              </nav>
            </div>
            
            {/* Contact Info - Spans full width on mobile */}
            <div className="sm:col-span-2 lg:col-span-1 space-y-3 sm:space-y-4">
              <h4 className="font-medium text-sm sm:text-base text-foreground">Kontakt</h4>
              <div className="space-y-2 sm:space-y-3">
                <div>
                  <div className="text-xs font-medium text-foreground">Telefon</div>
                  <div className="text-xs text-foreground/75 whitespace-nowrap">+49 4141 - 426310</div>
                </div>
                <div>
                  <div className="text-xs font-medium text-foreground">E-Mail</div>
                  <div className="text-xs text-foreground/75 whitespace-nowrap">m.scholz@scholz-interim.de</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Bottom Bar - Optimized for mobile */}
          <div className="pt-6 sm:pt-8 border-t border-border/30 space-y-3 sm:space-y-0 sm:flex sm:flex-row sm:justify-between sm:items-center">
            <p className="text-xs text-foreground/75 text-center sm:text-left">
              © 2025 Scholz & Scholz Recruitment UG
            </p>
            <p className="text-xs text-foreground/75 text-center sm:text-left sm:max-w-md px-2 sm:px-0">
              Aus Gründen der Lesbarkeit gelten alle Personenbezeichnungen gleichermaßen für alle Geschlechter (m/w/d).
            </p>
            <div className="flex items-center justify-center sm:justify-end gap-4 sm:gap-6">
              <Link to="/impressum" className="text-xs text-foreground/70 hover:text-foreground transition-smooth">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-xs text-foreground/70 hover:text-foreground transition-smooth">
                Datenschutz
              </Link>
              <Link to="/agb" className="text-xs text-foreground/70 hover:text-foreground transition-smooth">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};